import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

const translations = {
  fr: {
    portalTitle: "Portail Luniwave.",
    descriptionPart1: "Une écologie positive et rentable",
    descriptionPart2: "pour le secteur du tourisme.",
    connexion: "Connexion",
    notClientYet: "Pas encore client ?",
    contactUs: "Nous contacter",
    signIn: "Se connecter",
  },
  en: {
    portalTitle: "Luniwave Portal.",
    descriptionPart1: "A positive ecological impact",
    descriptionPart2: "for the tourism sector.",
    connexion: "Login",
    notClientYet: "Not a client yet ?",
    contactUs: "Contact us",
    signIn: "Sign in",
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage or default to 'fr'
    return localStorage.getItem("luniapp_language") || "fr";
  });

  useEffect(() => {
    // Save language preference to localStorage
    localStorage.setItem("luniapp_language", language);
  }, [language]);

  const t = translations[language] || translations.fr;

  const toggleLanguage = () => {
    setLanguage((prevLang) => (prevLang === "fr" ? "en" : "fr"));
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

